var _g, _g2, _path, _g3, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVehicleMoveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 61,
    viewBox: "0 0 231 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2148_22968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.4809 9H7.61483C3.71185 9 0.547852 12.164 0.547852 16.067V44.933C0.547852 48.836 3.71185 52 7.61483 52H36.4809C40.3839 52 43.5479 48.836 43.5479 44.933V16.067C43.5479 12.164 40.3839 9 36.4809 9Z",
    fill: "#ECD3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.61483 9.29861H36.4809C40.2189 9.29861 43.2492 12.3289 43.2492 16.067V44.933C43.2492 48.6711 40.2189 51.7014 36.4809 51.7014H7.61483C3.87677 51.7014 0.846463 48.6711 0.846463 44.933V16.067C0.846463 12.3289 3.87677 9.29861 7.61483 9.29861Z",
    stroke: "white",
    strokeWidth: 0.597222
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_2148_22968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.635 38.4727H10.5682C10.4362 38.45 10.3013 38.45 10.1694 38.4727C10.0887 38.4894 10.0173 38.5357 9.96904 38.6024C9.92079 38.6691 9.89923 38.7514 9.9086 38.8332C9.9106 38.9214 9.94704 39.0052 10.0101 39.0669C10.0732 39.1285 10.1579 39.163 10.246 39.163H13.0223C13.4595 39.163 13.4595 39.163 13.4595 39.6155V40.2904C13.4725 40.3759 13.4652 40.4634 13.4382 40.5456C13.4112 40.6279 13.3652 40.7026 13.304 40.7638C13.2428 40.825 13.1681 40.871 13.0858 40.898C13.0036 40.925 12.9162 40.9323 12.8306 40.9193H8.05263C7.56179 40.9193 7.37773 40.7352 7.37773 40.252V37.0923C7.33385 36.0653 7.23658 35.0414 7.08629 34.0246C6.97892 32.8818 6.76418 31.7238 6.73351 30.5887C6.7289 29.7226 6.98351 28.8748 7.46459 28.1546C7.94568 27.4343 8.63124 26.8745 9.4331 26.547C9.59416 26.501 9.6095 26.4396 9.50979 26.3016C9.36405 26.0742 9.1448 25.9037 8.88858 25.8184C8.20601 25.6037 7.52344 25.3736 6.83321 25.1282C6.38072 24.9748 6.35004 24.8981 6.58012 24.4916L6.89456 23.9241C6.93863 23.8289 7.01291 23.751 7.10584 23.7025C7.19877 23.654 7.30514 23.6375 7.40841 23.6557L9.83957 23.9394C9.89023 23.9385 9.94038 23.9496 9.98596 23.9717C10.0315 23.9938 10.0713 24.0263 10.1019 24.0667C10.1325 24.107 10.1532 24.154 10.1623 24.2039C10.1713 24.2537 10.1685 24.305 10.154 24.3536C10.108 24.6757 10.0697 24.9978 10.039 25.3199C10.0495 25.4533 10.091 25.5824 10.1602 25.6969C10.2295 25.8114 10.3245 25.9082 10.4378 25.9795C10.5835 26.0408 10.5758 25.9028 10.6065 25.8414C10.8059 25.3429 11.0053 24.8521 11.197 24.3536C11.6495 23.1955 12.1097 22.0528 12.5545 20.8794C12.6164 20.6905 12.7321 20.5238 12.8874 20.3999C13.0428 20.2759 13.2309 20.2 13.4288 20.1815C14.7556 19.9744 16.0901 19.775 17.4322 19.6676C19.3957 19.4964 21.368 19.4477 23.3376 19.5219C24.9098 19.5909 26.4743 19.7136 28.0388 19.9207C28.6754 19.9974 29.3119 20.1124 29.9562 20.2045C30.1346 20.2332 30.3013 20.3118 30.437 20.4312C30.5727 20.5507 30.6719 20.706 30.7231 20.8794C31.352 22.495 31.9834 24.1081 32.6174 25.7187C32.6174 25.7954 32.6788 25.8644 32.7094 25.9411C32.7401 26.0178 32.7861 26.0255 32.8398 25.9411C33.0239 25.757 33.277 25.6113 33.231 25.2815L33.1159 24.2845C33.1039 24.2405 33.1023 24.1942 33.1115 24.1494C33.1206 24.1046 33.1402 24.0626 33.1685 24.0268C33.1969 23.9909 33.2333 23.9623 33.2748 23.9431C33.3163 23.9239 33.3617 23.9148 33.4074 23.9164L35.8922 23.625C35.987 23.6111 36.0838 23.6283 36.1681 23.6739C36.2524 23.7195 36.3197 23.7911 36.36 23.8781L36.7435 24.6066C36.8892 24.8827 36.8509 24.9978 36.5594 25.0975L34.3353 25.8644C34.2125 25.8951 34.0992 25.9557 34.0056 26.0408C33.6144 26.4089 33.6298 26.4549 34.1053 26.6697C34.6927 26.9561 35.206 27.3744 35.6051 27.8919C36.0042 28.4094 36.2783 29.0121 36.406 29.653C36.5296 30.3094 36.5296 30.983 36.406 31.6394C36.2527 32.9815 36.1069 34.3237 35.9382 35.6658C35.8281 37.197 35.7948 38.7328 35.8385 40.2674C35.8385 40.8272 35.6775 40.9883 35.0716 40.9883H30.47C29.9255 40.9883 29.7568 40.8119 29.7568 40.275C29.7568 40.0296 29.7568 39.7842 29.7568 39.5081C29.7568 39.232 29.8258 39.186 30.0635 39.1937H32.7325C33.1313 39.1937 33.3153 39.071 33.3153 38.8255C33.3153 38.5801 33.1159 38.4651 32.7248 38.4651L21.635 38.4727ZM21.635 26.3552H31.2139C31.5437 26.3552 31.5437 26.3552 31.421 26.0408C30.8484 24.5734 30.2757 23.1137 29.7031 21.6616C29.6802 21.5812 29.6335 21.5096 29.5692 21.4562C29.5049 21.4028 29.4259 21.3702 29.3426 21.3625C27.4439 21.0512 25.5283 20.854 23.606 20.772C22.1641 20.7183 20.7223 20.726 19.2882 20.772C17.5089 20.864 15.7449 21.0788 13.981 21.3395C13.8931 21.3442 13.8088 21.3763 13.74 21.4314C13.6713 21.4864 13.6214 21.5615 13.5975 21.6463C13.0377 23.0958 12.4625 24.5376 11.8949 25.9795C11.7569 26.3322 11.7569 26.3322 12.125 26.3322L21.635 26.3552ZM21.635 36.7088H28.407C28.8901 36.7088 29.381 36.7088 29.8641 36.7088C29.9252 36.7173 29.9874 36.7118 30.046 36.6926C30.1047 36.6735 30.1582 36.6413 30.2025 36.5984C30.2469 36.5556 30.2809 36.5032 30.302 36.4453C30.3231 36.3873 30.3307 36.3253 30.3243 36.264C30.3243 35.8192 30.3243 35.382 30.3243 34.9372C30.3274 34.8829 30.3194 34.8286 30.3008 34.7775C30.2822 34.7264 30.2533 34.6797 30.2159 34.6402C30.1786 34.6007 30.1336 34.5693 30.0836 34.5478C30.0337 34.5263 29.9799 34.5153 29.9255 34.5154H13.6589C13.5619 34.5076 13.4644 34.5076 13.3675 34.5154C13.3124 34.5152 13.2579 34.5265 13.2074 34.5484C13.1569 34.5703 13.1115 34.6025 13.074 34.6428C13.0366 34.6832 13.0079 34.7308 12.9897 34.7828C12.9716 34.8348 12.9644 34.89 12.9687 34.9449C12.9687 35.382 12.9687 35.8268 12.9687 36.2717C12.9654 36.3303 12.9744 36.3889 12.9952 36.4438C13.0159 36.4988 13.0478 36.5488 13.089 36.5906C13.1301 36.6325 13.1795 36.6653 13.2341 36.687C13.2887 36.7087 13.3471 36.7187 13.4058 36.7165H21.6426L21.635 36.7088ZM21.635 32.9585H27.4636C27.5888 32.9662 27.7143 32.9662 27.8394 32.9585C28.0235 32.9585 28.0695 32.8358 27.9775 32.6748C27.8855 32.5137 27.6324 32.1456 27.479 31.9078C27.395 31.7375 27.2592 31.5983 27.0911 31.5101C26.9229 31.4219 26.7312 31.3893 26.5433 31.417C25.9911 31.4553 25.4466 31.417 24.8944 31.4937C24.1275 31.555 23.3606 31.4937 22.5936 31.555C21.3435 31.6394 20.0934 31.5167 18.8433 31.555C18.7897 31.555 18.736 31.555 18.6823 31.555L16.5272 31.4783C16.3914 31.4698 16.256 31.4998 16.1366 31.5649C16.0172 31.6301 15.9186 31.7277 15.8523 31.8465C15.7219 32.0612 15.5762 32.2683 15.4535 32.4907C15.3308 32.7131 15.1697 32.7898 15.2618 32.9662C15.3538 33.1426 15.5916 33.0736 15.7679 33.0736L21.635 32.9585ZM30.309 32.7054C31.2446 32.6441 32.0729 32.5904 32.8935 32.5214C33.1823 32.5022 33.4546 32.3797 33.6604 32.1763C34.0439 31.7928 34.4274 31.4093 34.8108 31.0412C34.9153 30.9468 34.9887 30.8231 35.0216 30.6862C35.0544 30.5494 35.0451 30.4057 34.9949 30.2743C34.9259 30.0825 34.8492 29.8908 34.7802 29.6914C34.6268 29.2849 34.4657 29.2159 34.0132 29.3616L33.0776 29.6991L29.3273 31.0642C28.9285 31.2022 28.8901 31.3556 29.1355 31.7008C29.2659 31.8848 29.404 32.0612 29.5267 32.2529C29.5995 32.3992 29.7143 32.5204 29.8564 32.601C29.9985 32.6816 30.1614 32.718 30.3243 32.7054H30.309ZM12.9687 32.7054C13.0997 32.7191 13.2321 32.6987 13.353 32.6463C13.4739 32.5939 13.5792 32.5113 13.6589 32.4063C13.8583 32.1456 14.0424 31.8771 14.2187 31.6394C14.3951 31.4017 14.3415 31.2253 14.0577 31.1179C13.7739 31.0105 13.3675 30.8648 13.0223 30.7344L9.21069 29.3463C8.84257 29.2082 8.68151 29.2926 8.54346 29.653C8.46677 29.8601 8.39008 30.0595 8.32105 30.2666C8.26655 30.3968 8.25426 30.5409 8.2859 30.6784C8.31754 30.816 8.39153 30.9402 8.49745 31.0335L9.64784 32.1686C9.84954 32.3791 10.1237 32.5052 10.4148 32.5214C11.2047 32.5904 12.0177 32.6441 12.9687 32.7054Z",
    fill: "#9629EB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.0294 42.3552C63.0727 34.1635 85.3819 22.8852 101.417 20.6139C118.742 18.1226 128.796 19.6846 149.434 28.2192C149.133 26.9501 148.77 25.9375 148.612 24.9841C148.384 23.9048 148.154 22.7616 148.198 21.6762C148.191 21.3574 148.791 20.7699 149.198 20.697C149.606 20.6241 150.297 21.0552 150.44 21.371C151.735 24.4042 152.893 27.4404 154.121 30.5388C154.484 31.5514 154.092 32.3257 152.941 32.6703C148.536 33.7892 144.132 34.9718 139.657 36.0285C138.639 36.2425 137.407 36.0148 136.045 36.0452C137.074 33.2792 139.533 33.5433 141.289 32.8025C143.111 31.9963 145.077 31.506 147.444 30.6877C141.71 27.2431 135.938 25.1391 129.844 23.8715C107.518 19.1383 87.1773 23.9296 68.5653 35.9548C66.1469 37.5397 63.9386 39.3751 61.5898 41.0223C60.8475 41.3578 60.1733 41.6918 59.0294 42.3552Z",
    fill: "#2898A4"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_2148_22968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.427 0H179.477C173.941 0 169.452 4.48846 169.452 10.0253V50.9747C169.452 56.5115 173.941 61 179.477 61H220.427C225.964 61 230.452 56.5115 230.452 50.9747V10.0253C230.452 4.48846 225.964 0 220.427 0Z",
    fill: "#E9FFCD"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_di_2148_22968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.704 15.9316C219.004 16.0879 219.25 16.3318 219.408 16.6311C219.566 16.9303 219.629 17.2706 219.589 17.6066C219.589 25.1596 219.589 32.7125 219.589 40.2655C219.589 41.4411 219.089 41.9508 217.914 41.9508H181.928C180.742 41.9508 180.253 41.4515 180.253 40.2551C180.253 32.7125 180.253 25.1596 180.253 17.6066C180.217 17.2711 180.282 16.9325 180.439 16.6342C180.597 16.3358 180.84 16.0912 181.137 15.9316H218.704ZM199.978 39.8597H216.832C217.487 39.8597 217.497 39.8597 217.497 39.2251V18.6574C217.497 18.0123 217.497 18.0123 216.842 18.0123H183.135C182.448 18.0123 182.448 18.0123 182.448 18.7198V39.1211C182.448 39.8285 182.448 39.8285 183.176 39.8285L199.978 39.8597Z",
    fill: "#6FAA22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.874 42.6491H176.436H194.746C195.131 42.6491 195.485 42.6491 195.453 43.1692C195.453 43.4397 195.682 43.4189 195.87 43.4189H203.943C204.296 43.4189 204.536 43.4189 204.494 42.9404C204.494 42.7219 204.609 42.6387 204.817 42.6387H223.324C224.021 42.6387 224.105 42.7427 223.98 43.4397C223.896 43.8805 223.665 44.2797 223.325 44.5725C222.985 44.8653 222.556 45.0344 222.107 45.0523H221.639C207.157 45.0523 192.676 45.0523 178.194 45.0523C177.701 45.1073 177.204 44.9944 176.783 44.732C176.362 44.4696 176.042 44.073 175.874 43.6062V42.6491Z",
    fill: "#6FAA22"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2148_22968",
    x: -19.7577,
    y: -11.3056,
    width: 83.6111,
    height: 83.6111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10.1528
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2148_22968"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2148_22968",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_2148_22968",
    x: 2.85612,
    y: 17.0994,
    width: 42.3312,
    height: 29.8611,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.38889
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79167
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8 0 0 0 0 0.8 0 0 0 0 0.8 0 0 0 0.49 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2148_22968"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2148_22968",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.36111,
    dy: -2.38889
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.18056
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.895833 0 0 0 0 0.884635 0 0 0 0 0.884635 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2148_22968"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_2148_22968",
    x: 140.647,
    y: -28.8056,
    width: 118.611,
    height: 118.611,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 14.4028
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2148_22968"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2148_22968",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_di_2148_22968",
    x: 170.791,
    y: 12.5428,
    width: 65.0987,
    height: 40.9959,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.38889
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.54167
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8 0 0 0 0 0.8 0 0 0 0 0.8 0 0 0 0.49 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2148_22968"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2148_22968",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 11.8611,
    dy: -3.38889
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.93056
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.895833 0 0 0 0 0.884635 0 0 0 0 0.884635 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2148_22968"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleMoveIcon);
export default __webpack_public_path__ + "static/media/VehicleMoveIcon.db623b44c82bd6f07f950a5eef88f2a7.svg";
export { ForwardRef as ReactComponent };